export const history: {
  navigate: any;
  location: any;
} = {
  navigate: null,
  location: null,
};
